import { render, staticRenderFns } from "./ActivityWsVideo.vue?vue&type=template&id=abc20578&scoped=true"
import script from "./ActivityWsVideo.vue?vue&type=script&lang=ts"
export * from "./ActivityWsVideo.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsVideo.vue?vue&type=style&index=0&id=abc20578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc20578",
  null
  
)

export default component.exports